export const CRUD_PERMS = ['Create', 'View', 'Update', 'Delete'];
export const DefaultRole="default_role"
export const CustomRole="custom_role"
export const userRoleMap = new Map([
  ['operatorOperationUser', 'EV Operations User'],
  ['operatorBusinessUser', 'EV Business User'],
  ['providerOperationUser', 'Provider Operations User'],
  ['telcoOperationUser', 'Telco Operations User'],
  ['telcoBusinessUser', 'Telco Business User'],
  ['genericOperationUser', 'Operations User'],
  ['genericBusinessUser', 'Business User'],
  ['ISPOperationUser', 'ISP Operations User'],
  ['systemUser', 'System User'],
  ['telcoAdmin', 'Telco Admin'],
  ['operatorAdmin', 'Operator Admin'],
  ['genericAdmin', 'Generic Admin'],
  ['partnerAdmin', 'Partner Admin'],
  ['ISPOperatorAdmin', 'ISP Operator Admin'],
  ['ISPPartnerAdmin', 'ISP Partner Admin'],
  ['smartMeterAdmin', 'Smart Meter Admin'],
  ['ISPBusinessUser', 'ISP Business User'],
  ['SGCAdmin', 'SGC Admin'],
  ['SGCExecutiveUser', 'SGC Executive User'],
  ['SGCOperationsUser', 'SGC Operations User'],
  ['SGCPowerUser', 'SGC Power User'],
  ['evAdmin', 'EV Admin'],
]);

